<script>
localStorage.setItem("theme", "dark");
</script>

<template>
  <div class="w-screen h-screen bg-[#262b2c] p-5">
    <router-view class="w-full h-full" />
  </div>
</template>
